// Couleurs des exports image (dom-to-image) alignées sur le thème actif.
//
// Les exports utilisaient un fond « #1C2333 » codé en dur : un radar en thème
// clair finissait sur un fond bleu nuit illisible, et le thème sombre réel de
// l'utilisateur n'était pas respecté. On lit à la place les couleurs
// effectivement rendues à l'écran (variables CSS antd résolues).

const FALLBACK_BACKGROUND = '#ffffff';

const isTransparent = (color: string) =>
	!color || color === 'transparent' || /^rgba\(.*,\s*0(\.0+)?\)$/.test(color.replace(/\s+/g, ' '));

// Premier fond opaque en remontant depuis `el` : ce que l'utilisateur voit
// derrière l'élément exporté.
export const effectiveBackgroundColor = (el: Element | null): string => {
	for (let node: Element | null = el; node; node = node.parentElement) {
		const color = window.getComputedStyle(node).backgroundColor;
		if (!isTransparent(color)) return color;
	}
	return FALLBACK_BACKGROUND;
};

export const effectiveTextColor = (el: Element): string => window.getComputedStyle(el).color;

// Filigrane « Gerositus® - All rights reserved » dans la couleur demandée.
export const watermarkDataUri = (color: string): string => {
	const svg =
		'<?xml version="1.0" encoding="utf-8"?>' +
		'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 166 14.2">' +
		`<style type="text/css">.st0{fill:${color}; font-family:'ArialMT', sans-serif; font-size:12px;}</style>` +
		'<text class="st0">Gerositus® - All rights reserved</text>' +
		'</svg>';
	return `url(data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))})`;
};
